import { ReactElement } from "react";
import { useAppSelector } from "../app/hooks";
import { CommonState } from "../app/interfaces/common";
import { marketUrl } from "../app/config";
import { Pipes } from "./Pipes";
import { ymEvent } from "../app/utils/metrix";

export const AuthPopup = (): ReactElement => {
  const { code} = useAppSelector((state: CommonState) => state.app)

  const content = (() => {
      return (
        <>
          <h1 className={'headline headline_popup'}>Твой промокод уже<br/> на почте!
            Проверь свои сообщения.</h1>
          <div>
          </div>
          <div className={'promo-buttons'}>
            <a href={marketUrl}
               onClick={() => ymEvent('market_link_click')}
               target={'_blank'} rel="noreferrer"
               className={'button button_long-text button_auth-popup button_lined button_green'}>
              За покупками в Мегамаркет
            </a>
          </div>
        </>
      )
  })()
  return (
    <div className={'popup'}>
      <div className={'popup__overflow'}></div>
      <div className={'popup__content'}>
        <div className={'percent-gear percent-gear_' + code}></div>
        <div className={'popup__content-white-bg'}/>
        <div className={'popup__stuff-over-bg'}>
          {content}
        </div>
        <Pipes/>
      </div>
    </div>
  )
}
